// ME
export const SET_ME = 'SET_ME';
export const SET_DOCUMENTS_LOADING = 'SET_DOCUMENTS_LOADING';
export const SET_DOCUMENTS = 'SET_DOCUMENTS';
export const SET_MEMBER_STATS = 'SET_MEMBER_STATS';
